import 'react-daum-postcode';
interface setProps {
  setFirAddr?: React.Dispatch<React.SetStateAction<string>>;
  setPostCode?: React.Dispatch<React.SetStateAction<string>>;
  setDetail?: React.Dispatch<React.SetStateAction<string>>;
}
interface IAddr {
  address: string;
  zonecode: string;
  needReturn?: true;
}

const SearchAddrApi = (
  props: setProps
): Promise<{ addr_num: string; addr_basic: string }> => {
  const { setFirAddr, setPostCode, setDetail } = props;
  const postcode = window.daum?.Postcode;
  if (!postcode) return Promise.reject(new Error('주소 검색을 불러오지 못했습니다.'));

  return new Promise((resolve) => {
    new postcode({
      oncomplete: function (data: IAddr) {
        if (setFirAddr) setFirAddr(data.address);
        if (setPostCode) setPostCode(data.zonecode);
        if (setDetail) setDetail("");

        const addr_num = data.zonecode;
        const addr_basic = data.address;
        resolve({ addr_num, addr_basic });
      },
    }).open();
  });
};

export default SearchAddrApi;
